import React, { useEffect, useState } from 'react'
import Select from 'react-select/creatable';
import classes from './IndentReport.module.css'
import { toast } from 'react-toastify';
import Loader from '../../Loader/Loader';
import axios from '../../../Axios/Axios';
import { DateFormatter1, DateFormatter2 } from '../../../Constants';
import { Urls } from '../../../Urls';
import { useIndentTracking } from '../hooks/useIndentTracking';

export const DownloadIndentReports = ({ days, bucket, level, indent_type }) => {
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()
    const [currentDate, setCurrentDate] = useState()
    const [intervalDays, setIntervalDays] = useState(days)
    const [indentBucket, setIndentBucket] = useState(bucket)
    const [indentLevel, setIndentLevel] = useState(level)
    const [reportData, setReportData] = useState()
    const [show, setshow] = useState(false)
    const [max_range, setmax_range] = useState()
    const {trackIndentEvent} = useIndentTracking()

    useEffect(() => {
      trackIndentEvent(`indent request : ${indent_type}`, "user has viewed the indent report page")
    }, [])

    useEffect(() => {
        var dt = new Date();
        dt.setDate(dt.getDate() - intervalDays);
        const ninetydays = new Date();    //30/6
        ninetydays.setDate(ninetydays.getDate() - 90);  //1/4
        if(dt < ninetydays){  // dt earlier than ninetydays
            dt=ninetydays;
        }
        var day1 = ("0" + (dt.getDate())).slice(-2)
        var month1 = ("0" + (dt.getMonth() + 1)).slice(-2)
        var year1 = dt.getFullYear()
        var previousDate = year1.toString() + '-' + month1.toString() + "-" + day1.toString() + ""
        setStartDate(startDate ? startDate : previousDate)
        // console.log(previousDate, 'previousDate');

        var rangeDate = new Date();
        rangeDate.setDate(rangeDate.getDate() - 90);
        var day2 = ("0" + (rangeDate.getDate())).slice(-2)
        var month2 = ("0" + (rangeDate.getMonth() + 1)).slice(-2)
        var year2 = rangeDate.getFullYear()
        var range = year2.toString() + '-' + month2.toString() + "-" + day2.toString() + ""
        setmax_range(range)
        // console.log(range, 'range')

        var mindate = new Date()
        var day = ("0" + (mindate.getDate())).slice(-2)
        var month = ("0" + (mindate.getMonth() + 1)).slice(-2)
        var year = mindate.getFullYear()
        var todaydate = year.toString() + '-' + month.toString() + "-" + day.toString() + ""
        setEndDate(todaydate)
        setCurrentDate(todaydate)
        getReports()
    }, [])

    // Function to fetch reports based on selected filters
    const getReports = () => {
        setshow(true)
        axios.get(`${Urls.report_generator}/report_generator?module=${indent_type}`)
        .then((res) => {
            setshow(false)
            // console.log(res.data, 'get response')
            setReportData(res.data)
        })
        .catch((error) => {
            console.log(error)
        })
    }

    // Function to format date in UTC format
    const UTCFormatter = (value) => {
        var newDate = new Date(value)
        return newDate.toISOString();
    }

    // Function to format date in UTC format with specific time
    const UTCFormatter1 = (value) => {
        var newDate = new Date(value)
        var str = newDate.toISOString().split("T")[0]
        var time = "T23:59:59Z"
        var finalUrl = str + time;
        return finalUrl;
    }

    // Function to handle form submission and trigger report generation
    const submitHandler = () => {

        trackIndentEvent(
            `indent request : ${indent_type}`, 
            "user has submitted the indent report generation request", 
            `from : ${startDate}, to : ${endDate}, view : ${indentLevel}, bucket : ${indentBucket}`
        )

        if(indent_type === 'indent_track'){
            var payload = {
                "activity": "Report Generation Request",
                "module": "indent_track",
                "filters": {
                    "from": UTCFormatter(startDate),
                    "to": UTCFormatter1(endDate),
                    "view": indentLevel,
                },
                "report_status": "pending",
                "email": `${localStorage.getItem("useremail")}`,
            }
        } 
        else {
            var payload = {
                "activity": "Report Generation Request",
                "module": "indent",
                "filters": {
                    "from": UTCFormatter(startDate),
                    "to": UTCFormatter1(endDate),
                    "view": indentLevel,
                    "bucket": indentBucket,
                },
                "report_status": "pending",
                "email": `${localStorage.getItem("useremail")}`,
            }
        }

        var indent_payload = {
            "bucket": indentBucket,
            "from": UTCFormatter(startDate),
            "to": UTCFormatter1(endDate),
            "email": `${localStorage.getItem("useremail")}`,
            "view": indentLevel,
            "skip": 0,
            "limit": 3,
        }

        const fromDate = new Date(startDate);
        const toDate = new Date(endDate);
        const diffInDays = Math.floor((toDate - fromDate) / (1000 * 60 * 60 * 24));
        if (diffInDays <= 90) {
        axios.post(`${Urls.indent}?field=get_indents`, indent_payload)
        .then((res) => {
            // console.log(res.data, 'res')
            if(res.data && res.data.indents && res.data.indents.length > 0){
                // console.log('logApi call');
                setshow(false)
                axios.post(`${Urls.logURL}`, payload)
                .then((response) => {
                    // console.log(response.data, 'res2')
                    toast.success('You will be notified via email once the report is generated')
                    getReports()
                })
                .catch((err) => {
                    console.log(err)
                })
            } else {
                setshow(false)
                toast.info('No Enquiries Found')
            }
        })
        .catch((error) => {
            setshow(false)
            console.log(error)
        })
    }else{
        toast.info('Please select 3 months interval')
    }    
    }

     // Function to handle downloading the generated report
    const downloadReport = (data) => {
        trackIndentEvent(
            `indent request : ${indent_type}`, 
            "user has downloaded the generated indent report", 
            `from : ${data.filters.from}, to : ${data.filters.to}, view : ${data.filters.view}, bucket : ${data.filters.bucket ? data.filters.bucket : 'NA'}`
        )

        setshow(true)
        if(data && data.blob_uri){
            setshow(false)
            window.open(data.blob_uri, "_parent")
        } else {
            setshow(false)
            toast.error('Please try after sometime!')
        }
    }

    return (
        <div className='px-4' id='report-generator'>
            <Loader show={show} />
            <div className={`d-flex justify-content-between ${classes['input-fields']} mt-2`}>
                <div>
                    <label>From</label><br />
                    <div style={{ width: "95%" }}>
                        <input type="date"
                            defaultValue={startDate}
                            min={max_range}
                            max={endDate}
                            style={{ height: '38px' }}
                            onInput={e => {
                                // console.log(e.target.value, 'from')
                                setStartDate(e.target.value)
                            }}
                        ></input>
                    </div>
                </div>
                <div>
                    <label>To</label><br />
                    <div style={{ width: "95%" }}>
                        <input type="date"
                            defaultValue={endDate}
                            min={startDate}
                            max={currentDate}
                            style={{ height: '38px' }}
                            onInput={e => {
                                // console.log(e.target.value, 'to')
                                setEndDate(e.target.value)
                                var newDate = new Date(e.target.value)
                                newDate.setDate(newDate.getDate() - 90)
                                var day = ("0" + (newDate.getDate())).slice(-2)
                                var month = ("0" + (newDate.getMonth() + 1)).slice(-2)
                                var year = newDate.getFullYear()
                                var range = year.toString() + '-' + month.toString() + "-" + day.toString() + ""
                                setmax_range(range)
                            }}
                        ></input>
                    </div>
                </div>
                {indent_type === 'indent' ? 
                    <div className={`${classes['select-options']}`}>
                        <label>Indent Type</label>
                        <Select
                            options={[{ label: 'All Indents', value: "all" }, { label: 'Active Indents', value: "active" }, { label: 'Expired Indents', value: "expired" }, { label: 'Cancelled Indents', value: "cancelled" }]}
                            onChange={e => {
                                setIndentBucket(e.value)
                            }}
                            isSearchable={false}
                            isMulti={false}
                            value={indentBucket === 'all' ? { label: 'All Indents', value: "all" } : indentBucket === 'active' ? { label: 'Active Indents', value: "active" } : indentBucket === 'expired' ? { label: 'Expired Indents', value: "expired" } : indentBucket === 'cancelled' ? { label: 'Cancelled Indents', value: "cancelled" } : ''}
                        />
                    </div>
                : null}
                <div className={`${classes['select-options']}`}>
                    <label>User Type</label>
                    <Select
                        options={[{label:'My Indents', value:"user_view"},{label:'Company Indents', value:"company_view"}]}
                        onChange={e => {
                            setIndentLevel(e.value)
                        }}
                        isSearchable={false}
                        isMulti={false}
                        classNamePrefix={"Truck_Prefix"}
                        value={indentLevel === 'user_view' ? { label: 'My Indents', value: "user_view" } : indentLevel === 'company_view' ? { label: 'Company Indents', value: "company_view" } : ''}
                    />
                </div>
                <button className={`btn btn-sm btn-primary ${classes['submit-button']}`} onClick={submitHandler}>Submit</button>
                {/* </div> */}
            </div>

            <p></p>
            <div className={`mt-5 border ${classes['report-table']}`}>
                <table className={`table table-borderless ${classes['report-head']}`}>
                    <thead>
                        <tr>
                            <th className='text-center'>Sr. No.</th>
                            <th className='text-center'>Requested Data</th>
                            <th className='text-center'>Requested On</th>
                            <th className='text-center'>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody className={`${classes['report-body']}`}>
                        {reportData && reportData.length > 0 ? reportData.map((data, index) => {
                            return <tr>
                                <td>{index + 1}.</td>
                                <td>
                                    {indent_type === 'indent' ? 
                                        <div>{data.filters.bucket === 'all' ? <div>All Indents - {data.filters.view === "user_view" ? 'User' : 'Company'}</div>
                                        : data.filters.bucket === 'active' ? <div>Active Indents - {data.filters.view === "user_view" ? 'User' : 'Company'}</div>
                                        : data.filters.bucket === 'expired' ? <div>Archived Indents - {data.filters.view === "user_view" ? 'User' : 'Company'}</div>
                                            : data.filters.bucket === 'cancelled' ? <div>Cancelled Indents - {data.filters.view === "user_view" ? 'User' : 'Company'}</div>
                                                : ''
                                        }</div>
                                    : 
                                    <div>
                                        {data.filters.view === "user_view" ? <div>User Indents</div> : <div>Company Indents</div>}
                                    </div>
                                    }
                                    
                                    <hr className={`${classes['dash-line']}`} />
                                    {/* <div className='border'>{DateFormatter1(data.filters.from)}</div> */}
                                    <div>{`${DateFormatter2(data.filters.from.split('T')[0])} to ${DateFormatter2(data.filters.to.split('T')[0])}`}</div>
                                </td>
                                <td>{DateFormatter1(data.timestamp)}</td>
                                <td>{data.report_status === 'pending' ? <div>In Progress</div> : data.report_status === 'success' ? <div>Completed</div> : data.report_status === 'failed' ? <div>Failed</div> : ''}</td>
                                <td className='text-left'>
                                    {data && data.report_status === 'success' ?
                                        <button className={`btn btn-sm btn-success ${classes['download-report']}`} onClick={(e) => downloadReport(data)}><i className="fa fa-download"></i></button>
                                        : ''
                                    }
                                </td>
                            </tr>
                        }) :
                            <tr>
                                <td></td>
                                <td>No Reports</td>
                            </tr>}
                    </tbody>
                </table>
            </div>

            <p className={`font-italic ${classes['view-note']}`}>Note: The generated report will be available for 24Hrs from time of generation</p>
        </div>
    )
}